import type { SVGProps } from 'react';
const SvgSmokeFree = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#smoke_free_svg__a)">
      <path
        fill="currentColor"
        d="m2 6 6.99 7H2v3h9.99l7 7 1.26-1.25-17-17L2 6Zm18.5 7H22v3h-1.5v-3ZM18 13h1.5v3H18v-3Zm.85-8.12c.62-.61 1-1.45 1-2.38h-1.5c0 1.02-.83 1.85-1.85 1.85v1.5c2.24 0 4 1.83 4 4.07V12H22V9.92c0-2.23-1.28-4.15-3.15-5.04ZM14.5 8.7h1.53c1.05 0 1.97.74 1.97 2.05V12h1.5v-1.59c0-1.8-1.6-3.16-3.47-3.16H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75V2a3.35 3.35 0 0 0 0 6.7Zm2.5 7.23V13h-2.93L17 15.93Z"
      />
    </g>
    <defs>
      <clipPath id="smoke_free_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSmokeFree;
